export function generateRandomPassword() {
  // Convert random number to base 36 and get 6 characters
  return Math.random().toString(36).substr(2, 6);
}
